import React, { useState } from 'react';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { Check } from 'lucide-react';

const BundleCard = ({ bundle, onAddToCart }) => {
  const [priceType, setPriceType] = useState('digital');
  
  const currentPrice = priceType === 'digital' ? bundle.digitalPrice : bundle.printedPrice;
  
  const handleAddToCart = () => {
    onAddToCart({
      ...bundle,
      priceType,
      price: currentPrice
    });
  };
  
  return (
    <Card className="card-hover-lift group overflow-hidden border-stone-taupe/20 hover:border-stone-taupe/40 bg-white h-full flex flex-col transition-all duration-300">
      <div className="relative h-56 overflow-hidden">
        <img
          src={bundle.image}
          alt={bundle.name}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
        />
        {bundle.popular && (
          <Badge className="absolute top-4 right-4 bg-charcoal-ink text-warm-ivory shadow-lg animate-in">
            Most Popular
          </Badge>
        )}
        {/* Subtle decorative overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-charcoal-ink/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
      </div>
      
      <CardHeader>
        <CardTitle className="text-2xl text-charcoal-ink">{bundle.name}</CardTitle>
        <CardDescription className="text-stone-taupe">{bundle.description}</CardDescription>
      </CardHeader>
      
      <CardContent className="flex-grow">
        <div className="space-y-3">
          <p className="text-sm font-medium text-charcoal-ink mb-2">Includes:</p>
          {bundle.includes.map((item, index) => (
            <div key={index} className="flex items-start gap-2">
              <Check className="w-4 h-4 text-stone-taupe flex-shrink-0 mt-0.5" />
              <span className="text-sm text-charcoal-ink/80">{item}</span>
            </div>
          ))}
        </div>
      </CardContent>
      
      <CardFooter className="flex flex-col gap-4 pt-6 border-t border-stone-taupe/10">
        <div className="w-full flex gap-2">
          <button
            onClick={() => setPriceType('digital')}
            className={`flex-1 py-2 px-4 rounded-lg text-sm font-medium transition-all duration-300 ${
              priceType === 'digital'
                ? 'bg-charcoal-ink text-warm-ivory shadow-md scale-105'
                : 'bg-soft-linen text-charcoal-ink hover:bg-stone-taupe/20 hover:scale-102'
            }`}
          >
            Digital
          </button>
          <button
            onClick={() => setPriceType('printed')}
            className={`flex-1 py-2 px-4 rounded-lg text-sm font-medium transition-all duration-300 ${
              priceType === 'printed'
                ? 'bg-charcoal-ink text-warm-ivory shadow-md scale-105'
                : 'bg-soft-linen text-charcoal-ink hover:bg-stone-taupe/20 hover:scale-102'
            }`}
          >
            Printed
          </button>
        </div>
        
        {priceType === 'printed' && (
          <div className="w-full bg-soft-linen p-3 rounded-lg border border-stone-taupe/20">
            <p className="text-xs text-charcoal-ink">
              <strong>Pricing Note:</strong> Bundle pricing includes design and up to 12 printed pieces per included item. Additional quantities are available for an added fee. Custom quotes are provided for large orders.
            </p>
          </div>
        )}
        
        <div className="w-full flex items-center justify-between">
          <div>
            <span className="text-3xl font-bold text-charcoal-ink">${currentPrice}</span>
          </div>
          <Button
            onClick={handleAddToCart}
            className="elevated-button bg-charcoal-ink hover:bg-charcoal-ink/90 text-warm-ivory shadow-md hover:shadow-lg"
          >
            Add to Cart
          </Button>
        </div>
      </CardFooter>
    </Card>
  );
};

export default BundleCard;